// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nie: CountryValidator<"ES"> = createValidator(
  "es.nie",
  67,
);

export default nie;
export const compact = nie.compact;
export const format = nie.format;
export const validate = nie.validate;
export const generate = (): string =>
  nie.generate?.() ??
  (() => {
    throw new Error(
      "Validator es.nie cannot generate values",
    );
  })();
